























import Vue from 'vue';
import { Membership } from '~/services/CandidateService';
import { commonProps } from '~/utils/candidate';

// Components
import Card from './Card.vue';
import MembershipListItem from '../components/MembershipListItem.vue';
import MembershipModal from '../modals/MembershipModal.vue';
import { DateComparerBuilder } from '~/utils/helpers/comparison';

export default Vue.extend({
    name: 'Membership',
    components: { Card, MembershipModal, MembershipListItem },
    props: {
        ...commonProps(),
    },
    data() {
        return {
            showModal: false,
        };
    },
    computed: {
        memberships(): Membership[] {
            const we = this.candidate.memberships;
            const cmp = new DateComparerBuilder<Membership>().buildComparer(
                m => m.start,
                false,
                true
            ).compare;
            we.sort(cmp);
            return we;
        },
        hasNoMemberships(): boolean {
            return !this.candidate.memberships.length;
        },
        cardTitle(): string {
            return this.hasNoMemberships
                ? this.$t('profile.memberships.titleWhenEmpty').toString()
                : this.$t('profile.memberships.title').toString();
        },
    },
});
